<template>
    <span id="TimePeriodNav" >
        <span
            @click="clickback" class="icon-toggle psDateToggle"
        ></span>
        {{label}}
        <span
            @click="clickforward" class="icon-play-24 psDateToggle"
        ></span>
    </span>
</template>

<script>
export default {
    name: "PsTimePeriodNav",
    props: {
        targetTable: {},
        timeperiod:{
            type: String,
            required: false,
            default: "PERIOD"
        },
        fiscalYear:{
            type:Number,
            default:0
        },
        fiscalPeriod:{
            type: Number,
            default:0
        },
        fiscalDay:{
            type: Number,
            default: 0
        },
        fiscalPeriodStart: {
            type: Date,
            default: () => { return new Date(1970, 1, 1) }
        },
        fiscalPeriodStop:{
            type: Date,
            default: () => { return new Date(1970, 1, 1) }
        },
        label:{
            type: String,
            default:""
        },
        date:{
            type: String,
            default: ""
        },
        fiscalYearStart: {
            type: Date,
            default: () => { return new Date(1970, 1, 1) }
        },
        fiscalYearStop:{
            type: Date,
            default: () => { return new Date(1970, 1, 1) }
        },
        NumOfPeriods:  {
            type: Number,
            default: 12
        },
        fiscalQuarter:{
            type: Number,
            default: 1
        },
        fiscalQuarterStart: {
            type:Date,
            default: () => { return new Date(1970, 1, 1) }
        },
        fiscalQuareterStop:{
            type: Date,
            default: () => { return new Date(1970, 1, 1) }
        },
        pageRendered:{
            type: Boolean,
            default: false
        },
        parentID:{
            type: String,
            default: ""
        }
    },
    data(){
        return {
        }
    },
    mounted(){
        window.Bus.$off("TimePeriodDataSet");
        window.Bus.$on("TimePeriodDataSet", (setprops) => {
            this.label = setprops.label;
            this.timeperiod = setprops.timeperiod;
            this.date = setprops.date;
            this.fiscalYear = setprops.fiscalYear;
            this.fiscalPeriod = setprops.fiscalPeriod;
            this.fiscalDay = setprops.fiscalDay;
            this.fiscalPeriodStart = new Date(setprops.fiscalPeriodStart);
            this.fiscalPeriodStop = new Date(setprops.fiscalPeriodStop);
            this.fiscalYearStart = new Date(setprops.fiscalYearStart);
            this.fiscalYearStop = new Date(setprops.fiscalYearStop);
            this.NumOfPeriods = setprops.numOfPeriods;
            this.fiscalQuarter = setprops.fiscalQuarter;
            this.fiscalQuarterStart = new Date(setprops.fiscalQuarterStart);
            this.fiscalQuarterStop = new Date(setprops.fiscalQuarterStop);
            var centerWidth = document.getElementsByClassName("p4-report")[0].offsetWidth / 2;
            var startOfSpan = document.querySelector('#TimePeriodNav').getBoundingClientRect().left;
            document.getElementById("TimePeriodNav").style.marginLeft = centerWidth - startOfSpan - 84 + 'px';  //84 = .5 * TimePeriodNav width
            document.getElementById("TimePeriodNav").style.visibility = "visible";
        });
    },
    methods:{
        clickback() {
            var DateObjDate = this.getDateParts(new Date(this.date));
            toggleGlobalDate(this.setNewDate(this.timeperiod, DateObjDate, -1));
        },
        clickforward(){
            var DateObjDate = this.getDateParts(new Date(this.date));
            toggleGlobalDate(this.setNewDate(this.timeperiod, DateObjDate, 1));
        },
        getDateParts(date){
            var month = date.getMonth();
            var day = date.getDate();
            var year = date.getFullYear();
            return new Date(year, month, day);
        },
        setNewDate(timeperiod, date, increment){
            switch(timeperiod){
                case "PERIOD":
                    if(increment>0){
                        return this.addDays(this.fiscalPeriodStop, 1);
                    }
                    else{
                        return this.addMonths(this.fiscalPeriodStart, -1);
                    }
                case "DAY":
                    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + increment);
                case "YEAR":
                    if(increment > 0){
                        return this.addDays(this.fiscalYearStop, 1);
                    }
                    else{
                        return this.addYears(this.fiscalYearStart, -1);
                    }
                case "YEAR_TO_DATE":
                    if(!this.isValidDate(date.getFullYear() + increment, date.getMonth(), date.getDate()))
                        return new Date(date.getFullYear() + increment, date.getMonth() + 1, 0);
                    else
                        return new Date(date.getFullYear() + increment, date.getMonth(), date.getDate());
                case "PERIOD_TO_DATE":
                    if(!this.isValidDate(date.getFullYear(), date.getMonth() + increment, date.getDate()))
                        return new Date(date.getFullYear(), date.getMonth() + increment + 1, 0);
                    else
                        return new Date(date.getFullYear(), date.getMonth() + increment, date.getDate());
                case "QUARTER":
                    if(increment > 0){
                        return this.addDays(this.fiscalQuarterStop, 1);
                    }
                    else{
                        return this.addMonths(this.fiscalQuarterStart, -3);
                    }
                case "QUARTER_TO_DATE":
                    if(!this.isValidDate(date.getFullYear(), date.getMonth() + (increment * 3), date.getDate()))
                        return new Date(date.getFullYear(), date.getMonth() + (increment * 3) + 1, 0);
                    else
                        return new Date(date.getFullYear(), date.getMonth() + (increment * 3), date.getDate());
                case "TRAILING_3":
                    return this.addMonths(date, 3 * increment);
                case "TRAILING_6":  
                    return this.addMonths(date, 6 * increment);
                case "TRAILING_9":
                    return this.addMonths(date, 9 * increment);
                case "TRAILING_12":
                    return this.addMonths(date, 12 * increment);
                case "TRAILING_18":
                    return this.addMonths(date, 18 * increment);
                case "FORWARD_3":
                    return this.addMonths(date, 3 * increment);
                case "FORWARD_6":  
                    return this.addMonths(date, 6 * increment);
                case "FORWARD_9":
                    return this.addMonths(date, 9 * increment);
                case "FORWARD_12":
                    return this.addMonths(date, 12 * increment);
                case "FORWARD_18":
                    return this.addMonths(date, 18 * increment);  
                case "2_YEAR":
                    return this.addYears(date, 2 * increment);
                case "LAST_7_DAYS":
                    return this.addDays(date, 7 * increment);
                case "LAST_2_WEEKS":
                    return this.addDays(date, 14 * increment);
                case "LAST_4_WEEKS":
                    return this.addDays(date, 28 * increment);
            }
        },
        isValidDate(year, month, day){
            var d = new Date(year, month, day);
            if(d.getFullYear() == year && d.getMonth() == month && d.getDate() == day)
                return true;
            else
                return false;
        },
        addDays(date, days){
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        },
        addMonths(date, months){
            var result = new Date(date);
            result.setMonth(result.getMonth() + months);
            return result;
        },
        addYears(date, years){
            var result = new Date(date);
            result.setYear(result.getFullYear() + years);
            return result;
        }
    }
}
</script>
<style>
 /*.psDateToggle {
     padding-left:0px
}*/
#TimePeriodNav{
    visibility: hidden;
}
</style>